import { Directive, input, effect, inject, DestroyRef, model } from '@angular/core';

@Directive({
    selector: '[timeDisabledDuration]',
})
export class TimeDisabledDurationDirective {
    private destroyRef = inject(DestroyRef);

    timeDisabledDuration = model<boolean>(false);
    disableDuration = input<number>(10000);

    private timeoutId: number | null = null;

    constructor() {
        effect(() => {
            if (this.timeDisabledDuration()) {
                this.disableElement();
            }
        });

        this.destroyRef.onDestroy(() => {
            if (this.timeoutId !== null) {
                window.clearTimeout(this.timeoutId);
            }
        });
    }

    private disableElement(): void {
        if (this.timeoutId !== null) {
            window.clearTimeout(this.timeoutId);
        }

        this.timeoutId = window.setTimeout(() => {
            this.timeoutId = null;
            this.timeDisabledDuration.set(false);
        }, this.disableDuration());
    }
}
